import handleEvents from "./handleEvents";
import { useRef, useEffect } from "react";

/**
 * A react hook to enable arrow key navigation on a component.
 * @param {*} param0
 * @returns a useRef, which can be applied to a component
 */
export default function useArrowKeyNavigation(props) {
  const { selectors, rightToLeft, changeShape, setPreviousShape } = props || {};
  const parentNode = useRef();

  useEffect(() => {
    const eventHandler = (event) => {
      handleEvents({
        event,
        parentNode: parentNode.current,
        selectors,
        rightToLeft,
        changeShape,
        setPreviousShape,
      });
    };
    document.addEventListener("keydown", eventHandler);
    return () => document.removeEventListener("keydown", eventHandler);
  }, []);

  return parentNode;
}